import Details from './Details';
import Aggregate from './Aggregate';

const Index = () => {
    return (
        <>
            <ul className="nav nav-pills mb-3 mt-4" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link py-3 mb-1 px-5 active" data-bs-toggle="pill" data-bs-target="#details" type="button" role="tab" aria-controls="details" aria-selected="true">ریز گزارشات</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#aggregate" type="button" role="tab" aria-controls="aggregate" aria-selected="false">گزارش تجمیعی</button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab" tabindex="0">
                    <Details />
                </div>  
                <div className="tab-pane fade" id="aggregate" role="tabpanel" aria-labelledby="aggregate-tab" tabindex="0">
                    <Aggregate />
                </div>
            </div>
        </>
    );
}

export default Index;